import { useDispatch } from "react-redux";
import { userLogOut } from "store/auth/action";

// material-ui
import { useTheme } from "@mui/material/styles";
import { IconButton, Tooltip } from "@mui/material";

// assets
import { IconLogout } from "@tabler/icons";

// ==============================|| LOGOUT BUTTON ||============================== //

const LogoutButton = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(userLogOut());
  };

  return (
    <Tooltip title="Cerrar Sesión">
      <IconButton
        onClick={handleLogout}
        sx={{
          transition: "all .2s ease-in-out",
          background: theme.palette.secondary.light,
          color: theme.palette.secondary.dark,
          "&:hover": {
            background: theme.palette.error.main,
            color: theme.palette.error.light,
          },
        }}
      >
        <IconLogout stroke={1.5} size="1.5rem" />
      </IconButton>
    </Tooltip>
  );
};

export default LogoutButton;
